import React, { useCallback, useEffect, useState } from 'react';
import { Card, Col, Form, notification, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useHistory, useParams } from 'react-router';
import SaveButton from 'components/SaveButton';
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
  dateToString,
  objectParValueToString,
  shouldUpdateCompare,
  toDatePickerDate,
} from 'utils/utils2';
import WizardTabs from 'components/WizardTabs';
import Page, { PageModalProps } from 'components/Page';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import Button from 'components/Button';
import Title from 'components/Title';
import IActions from 'icons/IActions';
import AssetCatalogButton, {
  AssetCatalogButtonProps,
} from '../components/AssetGeneralData/AssetCatalogButton';
import {
  getAssetUseByAssetID,
  createAsset,
  getAssetComponentPaymentSchedule,
  getAssetpaymentschedule,
  getConElementByAssetID,
  updateAsset,
  getAssetfutureValueList,
  EntityAdditionalAttributeRequest,
  ViewEntityAddAttributeResponse,
  getAssetServicesListByAssetid,
} from 'services/assets';
import { getFinAssetUseByAssetID } from 'services/finassets';
import { getFinConElementByAssetID } from 'services/finassets';
import DF from 'DisplayFramework';
import AssetGeneralData from '../components/AssetGeneralData';
import AssetComponents from '../components/AssetComponents';
import AssetExtraInfo from '../components/AssetExtraInfo';
import AssetDeprecation from '../components/AssetDeprecation';
import AssetConElement from '../components/AssetConElement';
import AssetMarketValue from '../components/AssetMarketValue';
import DocList from 'pages/Document/DocList';
import Accounting from 'components/Accounting';
import { useQuery } from 'react-query';
import { isBoolean, isNil, isNumber, sumBy } from 'lodash';
import { useGetAssetDetails } from './useGetAssetDetails';
import FormItem from 'antd/lib/form/FormItem';
import TabAssetSchedule from '../components/AssetSchedule';
import IrvScheduleModal from 'components/IrvScheduleModal';
import IrvScheduleButton from 'components/IrvScheduleButton';
import { getMyWizards } from 'services/workflow';
import GetLabel from 'DisplayFramework/components/GetLabel';
import TabAssetUse from '../components/AssetUse/AssetUse';
import AssetAdress from '../components/AssetAdress/AssetAdress';
import AssetUsers from '../components/AssetUsers';
import { useAttributeContextFramework } from 'DisplayFramework/hooks/useAttribute';
import moment from 'moment';
import ProcessFollowUp from 'components/ProcessFollowUp';
import AssetServices from '../components/AssetServices';
import {
  AssetCatalogComponentResponse,
  ParAssetCatalogOptionResponse,
} from 'services/assetconfig';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import AssetRepossession from '../components/AssetDeprecation copy/AssetRepossession';
import AssetFees from '../components/AssetFees';
import AssetLinksListCard from './AssetLinksListCard';
import ButtonOperation from 'components/ButtonOperation';
import ModalControllerNV from 'components/ModalControllerNV';
import AssetListOptionsModal from '../components/AssetListOptionsModal';
import { getParAssetUseByFilters } from 'services/pricing';
import SIList from 'pages/SupplierInvoice/SlList';

type AssetDetailsProps = PageModalProps & {
  assetid?: number;
  phaseprop: 'PROD' | 'PROPOSAL';
  onSave?: (asset: any) => void;
  asset?: any;
  flagreal?: boolean;
  iscreate?: boolean;
  display?: boolean;
  isproposalcreate?: boolean;
  status?: string;
  fromproposal?: boolean;
  hideSaveBtn?: boolean;
  proposalData?: any;
  rederect?: string;
  setisvisible?: any;
  ctstatus?: string;
  hideActionBtn?: boolean;
};

const AssetDetails = (props: AssetDetailsProps) => {
  const {
    rederect,
    setisvisible,
    assetid,
    asset: assetProp,
    visible = false,
    onCancel,
    showAsModal = false,
    flagreal,
    onSave,
    phaseprop,
    iscreate,
    display,
    hideSaveBtn,
    fromproposal = false,
    isproposalcreate,
    proposalData,
    ctstatus,
    hideActionBtn,
  } = props;

  const { id } = useParams<{
    id: string;
  }>();

  const getAssetId = () => {
    const ida = assetid ? assetid : id;
    if (isNaN(Number(ida))) return undefined;
    else return Number(ida);
  };

  const [assettaxamount, setassettaxamount] = useState<any>();


  const [refetchMarketValues, setrefetchMarketValues] = useState(false);

  const assetId = getAssetId();

  const { data: wizData } = useQuery(['getMyWizards'], () =>
    getMyWizards({
      entity: phaseprop === 'PROD' ? 'FINASSET' : 'ASSET',
    }).then((res) => res.data)
  );

  const [form] = useForm();
  const history = useHistory();
  const tabPosition = localStorage.getItem('tabposition') ?? 'left';
  form.setFieldsValue({ isCreate: assetId ? false : true });

  const isCreate = iscreate ?? assetId ? false : true;

  const {
    data,
    refetch,
    isFetching: isFetchingAsset,
  } = useGetAssetDetails(assetId, phaseprop);

  console.log('phaseprop::', phaseprop);

  const { data: finComElements } = useQuery(
    ['getFinConElementByAssetID', assetId, isFetchingAsset],
    () =>
      getFinConElementByAssetID({ assetid: assetId! }).then(
        (res) => res.list || []
      ),
    {
      enabled:
      phaseprop === 'PROD' && !isNil(assetId),
    }
  );

  const { data: listUse, refetch: refetchassetuse } = useQuery(
    ['getAssetUseByAssetID', assetId, isFetchingAsset],
    () =>
      getAssetUseByAssetID({ assetid: assetId! }).then((res) => res.list || []),
    {
      enabled: !isNil(assetId) && phaseprop === 'PROPOSAL',
    }
  );

  const { data: listFinAssetUse, refetch: refetchfinassetuse } = useQuery(
    ['getFinAssetUseByAssetID', assetId, isFetchingAsset],
    () =>
      getFinAssetUseByAssetID({ assetid: assetId! }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(assetId) && phaseprop === 'PROD',
    }
  );

  const listAssetUse = phaseprop === 'PROPOSAL' ? listUse : listFinAssetUse;

  const { data: assetFV, refetch: refetchassetFV } = useQuery(
    ['getAssetfutureValue', assetId, isFetchingAsset],
    () =>
      getAssetfutureValueList({ assetid: assetId! }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(assetId),
    }
  );

  const [state, setState] = useState<any>({
    unlockAssetModel: data?.catalogid ? false : true,
    attid: 0,
    assetfamily: { value: '', label: '' },
    assettype: { value: '', label: '' },
    assetcategory: { value: '', label: '' },
    assetmodel: { value: '', label: '' },
    assetsegment: { value: '', label: '' },
  });

  const { data: comElements } = useQuery(
    ['getConElementByAssetID', assetId, isFetchingAsset],
    () =>
      getConElementByAssetID({ assetid: assetId! }).then(
        (res) => res.list || []
      ),
    {
      enabled:
      phaseprop !== 'PROD' && phaseprop === 'PROPOSAL' && !isNil(assetId),
    }
  );

  const {
    data: assetServices,
    refetch: refetchassetServices,
    isFetching,
  } = useQuery(
    ['getAssetServicesListByAssetid', { assetid: assetId }, isFetchingAsset],
    () =>
      getAssetServicesListByAssetid({ assetid: assetId! }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(assetId),
    }
  );

  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

  const { data: assetSchedules } = useQuery(
    ['getAssetpaymentschedule', assetId, isFetchingAsset],
    async () =>
      await getAssetpaymentschedule({ assetid: assetId! }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(assetId),
    }
  );

  const asset = assetProp ?? data;

  const getAssetComponent = async (listComp: any) => {
    const result = listComp?.map(async (element: any) => {
      const assetCompSch = await getAssetComponentPaymentSchedule({
        compid: element.compid,
      });
      return { ...element, assetcompschedule: assetCompSch.list ?? [] };
    });
    const resultofPromises = await Promise.all(result);

    return resultofPromises;
  };

  const { data: attlist } = useAttributeContextFramework(
    'ASSET',
    phaseprop === 'PROPOSAL' ? 'ASSET' : 'FINASSET',
    '',
    '',
    objectParValueToString(state.assetfamily) ?? '',
    objectParValueToString(state.assettype) ?? '',
    objectParValueToString(state.assetcategory) ?? '',
    objectParValueToString(state.assetsegment) ?? '',
    objectParValueToString(state.assetmodel) ?? ''
  );

  useEffect(() => {
    if (listAssetUse || fromproposal) {
      form.setFieldsValue({
        listAssetUse: fromproposal ? asset.assetusereqList : listAssetUse,
      });
    }
    console.log('assetServices::', assetServices);
    if (assetServices) {
      form.setFieldsValue({
        assetServiceList: assetServices.map((serv) => {
          return {
            ...serv,
            startdate: serv.startdate
              ? toDatePickerDate(moment(serv.startdate).format('YYYY-MM-DD'))
              : null,
            enddate: serv.enddate
              ? toDatePickerDate(moment(serv.enddate).format('YYYY-MM-DD'))
              : null,
          };
        }),
      });
    }

    if (assetSchedules) {
      form.setFieldsValue({
        totalHoldBackAmount: sumBy(assetSchedules, 'holdbackamount'),
        assetscheduledamount: sumBy(assetSchedules, 'payamount'),
        assetschedules: assetSchedules?.map((ele: any) => ({
          ...ele,
          holdbackprevreleasedate: toDatePickerDate(
            ele.holdbackprevreleasedate
          ),
          holdbackreleasedate: toDatePickerDate(ele.holdbackreleasedate),
          paydate: toDatePickerDate(ele.paydate),
          payduedate: toDatePickerDate(ele.payduedate),
          previsionalduedate: toDatePickerDate(ele.previsionalduedate),
          action: 'UPDATE',
        })),
      });
    }
    if (asset) {
      if (!isNil(asset?.assetComponents))
        getAssetComponent(asset?.assetComponents).then((res) => {
          form.setFieldsValue({
            assetComponents: res?.map((comp: any) => {
              return {
                ...comp,
                supplier: {
                  tpid: comp.tpidsupplier,
                  tpname: comp.suppliername,
                  tpreference: comp.supplierreference,
                },
              };
            }),
          });
        });

      if (!isNil(asset?.entityAddAttributList)) {
        let test = {};

        asset?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value =
                isNil(att.attstringvalue) && att.displaytype === 'MANDATORY'
                  ? att.defautvalue
                  : att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              if (moment(att.attstringvalue, false).isValid()) {
                value = moment(att.attstringvalue, false);
              } else {
                value = null;
              }
            }

            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );

        form.setFieldsValue({ entityAddAttributList: test });
      }

      form.setFieldsValue({
        assetComponents: asset.assetComponents,
        assetmodel: {
          value: asset?.assetmodel ?? '',
          label: asset?.assetmodellabel ?? asset?.assetmodel ?? '',
        },
        assettaggrouping: asset?.assettaggrouping,
        assetsegment: {
          value: asset?.assetsegment ?? '',
          label: asset?.assetsegmentlabel ?? asset?.assetsegment ?? '',
        },
        assetcategorylabel: asset?.assetcategorylabel,
        assetvariant: asset?.assetvariant,
        assetversion: asset?.assetversion,
        assetfamily: {
          value: asset?.assetfamily ?? '',
          label: asset?.assetfamilylabel ?? '',
        },
        assettypelabel: asset?.assettypelabel,
        assettype: { value: asset.assettype, label: asset.assettypelabel },

        assetcategory: {
          value: asset.assetcategory,
          label: asset?.assetcategorylabel,
        },
        assetclass: asset.assetclass,
        assetconstructor: asset.assetconstructor,
        assetdeliverydate: toDatePickerDate(asset.assetdeliverydate),
        assetdeliveryreference: asset.assetdeliveryreference,
        assetexpdeliverydate: toDatePickerDate(asset.assetexpdeliverydate),
        assetdescription:
          asset.assetdescription !== ''
            ? asset.assetdescription
            : asset.assetlabel,
        assetgrossamount: asset.assetgrossamount,
        assetid: asset.assetid,
        cteid: asset.cteid,
        assetlabel: asset.assetlabel,

        assetmulticomponents: asset.assetmulticomponents,
        assetnetamount: asset.assetnetamount,
        assetorderdate: toDatePickerDate(asset.assetorderdate),
        assetorderreference: asset.assetorderreference,
        assetreference: asset.assetreference,
        assetrisklevel: asset.assetrisklevel,
        assetstatus: asset.assetstatus,
        statuslabel: asset?.assetstatusdate
          ? asset.statuslabel + ' (' + asset?.assetstatusdate + ')'
          : asset.statuslabel,
        status: asset.assetstatus,
        assettaxamount: asset.assettaxamount,

        chassisno: asset.chassisno,
        currcode: asset.currcode,
        deliveryadrcity: asset.deliveryadrcity,
        deliveryadrcountry: asset.deliveryadrcountry,
        deliveryadrregion: asset.deliveryadrregion,
        deliveryadrstreet1: asset.deliveryadrstreet1,
        deliveryadrstreet2: asset.deliveryadrstreet2,
        deliveryadrzipcode: asset.deliveryadrzipcode,
        engineno: asset.engineno,
        finAssetComponents: asset.finAssetComponents
          ? (asset as any).finAssetComponents.map((comp: any) => {
              return {
                ...comp,
                supplier: {
                  tpid: comp.tpidsupplier,
                  tpname: comp.suppliername,
                  tpreference: comp.supplierreference,
                },
              };
            })
          : [],
        fiscaldepreciationmethod: asset.fiscaldepreciationmethod,
        flagused: asset.flagused,
        plateno: asset.plateno,
        power: asset.power,
        kwhpower: asset.kwhpower,
        kwhproduction: asset.kwhproduction,
        kwhdegradation: asset.kwhdegradation,
        registrationno: asset.registrationno,

        registrationdate: toDatePickerDate(asset.registrationdate),
        firstregistrationdate: toDatePickerDate(asset.firstregistrationdate),
        registrationname: asset.registrationname,
        registrationcity: asset.registrationcity,
        fiscalpower: asset.fiscalpower,

        serialno: asset.serialno,
        suppliername: asset.suppliername, // internal usage only
        taxcode: asset.taxcode,
        taxrate: asset.taxrate,
        tpidsupplier: asset.tpidsupplier,
        weight: asset.weight,
        assetphase: asset.assetphase,
        supplier: {
          tpid: asset.tpidsupplier,
          tpreference: asset.supplierreference,
          tpname: asset.suppliername,
        },
        manufacturer: {
          tpid: asset.tpidmanufacturer,
          tpreference: asset.manufacturerreference,
          tpname: asset.manufacturername,
        },
        assetrvamount: asset.assetrvamount,
        assetunitnetamount: asset.assetunitnetamount,
        assetqty: asset.assetqty,
        assetqtyavailable: asset.assetqtyavailable,
        flagholdback: asset.flagholdback,
        holdbackpercentage: asset.holdbackpercentage ?? 0,
        holdbackamount: asset.holdbackamount,
        holdbackbeleasedate: toDatePickerDate(asset.holdbackbeleasedate),
        holdbackbeleasenbdays: asset.holdbackbeleasenbdays,
        catalogid: asset.catalogid,
        assetpictureurl:
          form.getFieldValue('assetpictureurl') ?? asset.assetpictureurl,
        assetidorigine: asset.assetidorigine,
        networkcode: asset.networkcode,
        tpidbroker: {
          tpid: asset.tpidbroker,
          tpname: asset.brokername,
          tpreference: asset.brokerreference,
        },
        assetfinamount: asset.assetfinamount,
        degfeesformula: asset.degfeesformula,
        spfeesformula: asset.spfeesformula,
        tpofformula: asset.tpofformula,
        age: asset.age,
        balersize: asset.balersize,
        separatortype: asset.separatortype,
        wheeldrive: asset.wheeldrive,
        transmission: asset.transmission,
        wheeltrack: asset.wheeltrack,
        lift: asset.lift,
        capacity: asset.capacity,
        tankcapacity: asset.tankcapacity,
        nbcampaign: asset.nbcampaign,
        threshinghours: asset.threshinghours,
        rotorhours: asset.rotorhours,
        totalhours: asset.totalhours,
        totalbalers: asset.totalbalers,
        country: asset.country,
      });
      setassettaxamount(asset.assettaxamount);

      setState({
        attid: 0,
        assetsegment: {
          value: asset?.assetsegment,
          label: asset?.assetsegmentlabel,
        },
        assetmodel: { value: asset?.assetmodel, label: asset?.assetmodellabel },
        assetfamily: {
          value: asset.assetfamily,
          label: asset?.assetfamilylabel ?? '',
        },
        assettype: { value: asset.assettype, label: asset.assettypelabel },
        assetcategory: {
          value: asset.assetcategory,
          label: asset?.assetcategorylabel,
        },
      });
    }
  }, [
    asset,
    form,
    visible,
    assetSchedules,
    listAssetUse,
    fromproposal,
    assetServices,
  ]);

  const convertAssetOptionToAssetComponents = (
    assetOptions: ParAssetCatalogOptionResponse[]
  ): any[] => {
    const compnentList: AssetCatalogComponentResponse[] = assetOptions.map(
      (option) => ({
        assetid: Number(assetId),
        compcategory: option.optcode,
        compcategorylabel: option.optcodelabel,
        compdescription: '',
        compdiscountamount: 0,
        compdiscountrate: 0,
        compfree1: '',
        compgrossamount: 0,
        compid: 0,
        compnetamount: 0,
        comporiginalnetamount: 0,
        comptaxamount: 0,
        comptype: 'OPT',
        comptypelabel: '',
        taxcode: option.opttaxcode,
        taxrate: 0,
        tpidsupplier: 0,
        suppliername: '',
        supplierreference: '',
        flagholdback: false,
        holdbackpercentage: 0,
        holdbackamount: 0,
        holdbackbeleasenbdays: 0,
        holdbackbeleasedate: '',
      })
    );

    return compnentList;
  };

  const onAssetSelect = useCallback<AssetCatalogButtonProps['onSelect']>(
    async (asset, nbasset, selectedServices, selectedOption) => {
      setState({
        attid: 0,
        assetsegment: {
          value: asset?.assetsegment,
          label: asset.assetsegmentlabel,
        },
        assetmodel: { value: asset?.assetmodel, label: asset.assetmodellabel },
        assetpictureurl: asset?.assetpictureurl,
        assetfamily: {
          value: asset.assetfamily,
          label: asset.assetfamilylabel,
        },
        assettype: { value: asset.assettype, label: asset.assettypelabel },
        assetcategory: {
          value: asset.assetcategory,
          label: asset?.assetcategorylabel,
        },
      });

      setassettaxamount(asset.assettaxamount);

      let lassetComponents = asset.assetCatalogComponents;
      if (selectedOption?.length! > 0) {
        lassetComponents.push({
          assetid: 0,
          compcategory: 'ASSET',
          compcategorylabel: asset.assetlabel,
          compdescription: asset.assetlabel,
          compdiscountamount: 0,
          compdiscountrate: 0,
          compfree1: '',
          compgrossamount: asset.assetgrossamountorigine,
          compid: asset.catalogid,
          compnetamount: asset.assetnetamountorigine,
          comporiginalnetamount: asset.assetnetamountorigine,
          comptaxamount:
            asset.assetgrossamountorigine - asset.assetnetamountorigine,
          comptype: 'ASSET',
          comptypelabel: 'Asset',
          flagholdback: false,
          holdbackamount: 0,
          holdbackbeleasedate: '',
          holdbackbeleasenbdays: 0,
          holdbackpercentage: 0,
          suppliername: asset.suppliername,
          supplierreference: asset.supplierreference,
          taxcode: asset.taxcode,
          taxrate: 0,
          tpidsupplier: asset.tpidsupplier,
        });
      }
      selectedOption?.forEach((opt) => {
        lassetComponents.push({
          assetid: 0,
          compcategory: opt.optcode,
          compcategorylabel: opt.optcodelabel,
          compdescription: opt.optcodelabel + ' : ' + opt.optvaluelabel,
          compdiscountamount: 0,
          compdiscountrate: 0,
          compfree1: '',
          compgrossamount: opt.optgrossamount,
          compid: opt.optid,
          compnetamount: opt.optnetamount,
          comporiginalnetamount: opt.optnetamount,
          comptaxamount: opt.opttaxamount,
          comptype: 'OPT',
          comptypelabel: 'Option',
          flagholdback: false,
          holdbackamount: 0,
          holdbackbeleasedate: '',
          holdbackbeleasenbdays: 0,
          holdbackpercentage: 0,
          suppliername: asset.suppliername,
          supplierreference: asset.supplierreference,
          taxcode: opt.opttaxcode,
          taxrate: 0,
          tpidsupplier: asset.tpidsupplier,
        });
      });

      form.setFieldsValue({
        catalogid: asset.catalogid,

        assetsegment: {
          value: asset.assetsegment,
          label: asset.assetsegmentlabel,
        },
        assettype: {
          value: asset.assettype,
          label: asset.assettypelabel,
        },
        assetfamily: {
          value: asset.assetfamily,
          label: asset.assetfamilylabel,
        },
        assetcategory: {
          value: asset.assetcategory,
          label: asset.assetcategorylabel,
        },
        assetmodel: {
          value: asset.assetmodel,
          label: asset.assetmodellabel,
        },
        assetmulticomponents: asset.assetmulticomponents,
        assetdescription:
          asset.assetdescription !== ''
            ? asset.assetdescription
            : asset.assetlabel,
        assetpictureurl: asset.assetpictureurl,
        assetlabel: asset.assetlabel,
        assetnetamount: asset.assetnetamount * nbasset,
        taxcode: asset.taxcode,
        assettaxamount: asset.assettaxamount * nbasset,
        assetgrossamount: asset.assetgrossamount * nbasset,

        assettaggrouping: asset.assettaggrouping,
        assetconstructor: asset.assetconstructor,
        assetComponents: lassetComponents,
        kwhpower: asset.kwhpower,
        kwhproduction: asset.kwhproduction,
        kwhdegradation: asset.kwhdegradation,
        currcode: asset.currcode,
        taxrate: asset.taxrate,
        tpidsupplier: asset.tpidsupplier,
        supplier: {
          tpid: asset.tpidsupplier,
          tpreference: asset.supplierreference,
          tpname: asset.suppliername,
        },
        manufacturer: {
          tpid: asset.tpidmanufacturer,
          tpreference: asset.manufacturerreference,
          tpname: asset.manufacturername,
        },
        suppliername: asset.suppliername,
        supplierreference: asset.supplierreference,
        assetunitnetamount: asset.assetnetamount,
        assetServiceList: selectedServices,
        assetqty: nbasset,
        assetqtyavailable: nbasset,
      });

      const listuse = await getParAssetUseByFilters({
        parAssetRequest: [
          {
            assetcategory: asset.assetcategory ?? '',
            assetfamily: asset.assetfamily,
            assetid: '' as any,
            assettype: asset.assettype,
            catalogid: asset.catalogid ?? '',
            offerid: '' as any,
            ofrid: '' as any,
            ofrtype: '',
            prcode: '',
          },
        ],
      }).then((res: any) => res.list);

      form.setFieldValue('listAssetUse', listuse);

      if (!isNil(asset?.entityAddAttributList)) {
        let test = {};

        asset?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value = att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              value = moment(att.atttextvalue);
            }

            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );
        form.setFieldsValue({ entityAddAttributList: test });
      }
    },
    [form]
  );

  const onFinish = () => {
    let values = form.getFieldsValue();

    form
      .validateFields()
      .then(() => {
        const assetdeliverydate = form.getFieldValue('assetdeliverydate');
        const assetorderdate = form.getFieldValue('assetorderdate');
        const assetComponents = form.getFieldValue('assetComponents');
        const assetid = form.getFieldValue('assetid');
        const cteid = form.getFieldValue('cteid');

        let entityAddAttribut = form.getFieldValue('entityAddAttributList');

        let entityAddAttributassets: any = attlist?.map(
          (att: any) => att?.attcode
        );
        let entityAddAttributList: EntityAdditionalAttributeRequest[] = [];

        if (entityAddAttribut !== undefined) {
          Object.keys(entityAddAttribut).forEach(function (key, index) {
            if (
              !isNil(entityAddAttributassets) &&
              entityAddAttributassets?.length > 0 &&
              entityAddAttributassets.includes(key)
            ) {
              let attnumericvalue: number = 0;
              let atttextvalue: string = '';
              let attbooleanvalue = null;
              let attstringvalue: string = '';
              if (isBoolean(entityAddAttribut[key])) {
                attbooleanvalue = Boolean(entityAddAttribut[key]);
              } else if (isNumber(entityAddAttribut[key])) {
                attnumericvalue = Number(entityAddAttribut[key]);
              } else if (String(entityAddAttribut[key])?.length < 100) {
                attstringvalue = entityAddAttribut[key];
              } else {
                atttextvalue = entityAddAttribut[key];
              }

              let attdatatype = attlist?.find(
                (attribute: any) => key === attribute.attcode
              );

              let entityAttribute = asset?.entityAddAttributList?.find(
                (attribute: any) => key === attribute?.attcode
              );

              let entityAddAttributData: EntityAdditionalAttributeRequest = {
                attbooleanvalue: attbooleanvalue ?? false,
                attcode: key,
                attnumericvalue: attnumericvalue,
                attstringvalue: attstringvalue,
                atttextvalue: atttextvalue,
                attdatatype: attdatatype.attdatatype,
                entity: entityAttribute?.entity ?? '',
                entityid: entityAttribute?.entityid ?? 0,
                id: entityAttribute?.id ?? 0,
              };

              entityAddAttributList.push(entityAddAttributData);
            }
          });
        }

        const data = {
          ...values,
          assetCatalog: asset?.assetCatalog,
          assetdescription:
            values.assetdescription !== ''
              ? values.assetdescription
              : values.assetlabel,
          assetusereqList: form.getFieldValue('listAssetUse'),
          assetsegment: objectParValueToString(values.assetsegment),
          assetfamily: objectParValueToString(values.assetfamily),
          assetfamilylabel: values.assetfamily?.label ?? values.assetfamily,
          assettype: objectParValueToString(values.assettype),
          assettypelabel:
            values.assettype?.label ??
            values.assettypelabel ??
            form.getFieldValue('assettypelabel'),
          assetcategory: objectParValueToString(values.assetcategory),
          assetmodel: objectParValueToString(values.assetmodel),
          assetmodellabel: values.assetmodel?.label ?? values.assetmodel,
          assettaggrouping: values.assettaggrouping,
          assetsegmentlabel:
            values.assetsegment?.label ?? values.assetsegment ?? '',
          assetcategorylabel:
            values.assetcategory?.label ??
            values.assetcategorylabel ??
            form.getFieldValue('assetcategorylabel'),
          assetclass: values.assetclass,
          tpidsupplier: values.supplier?.tpid,
          suppliername: values.supplier?.tpname,
          supplierreference: values.supplier?.tpreference,

          tpidmanufacturer: values.manufacturer?.tpid,
          manufacturername: values.manufacturer?.tpname,
          manufacturerreference: values.manufacturer?.tpreference,

          assetqty: values.assetqty,
          assetqtyavailable: values.assetqtyavailable,
          holdbackbeleasedate: dateToString(values.holdbackbeleasedate),
          assetexpdeliverydate: dateToString(values.assetexpdeliverydate),
          assetid,
          assetvariant: values.assetvariant,
          assetversion: values.assetversion,
          assetComponents: assetComponents ?? [],
          assetphase: assetProp ? asset?.assetphase : String(phaseprop),
          assetdeliverydate: dateToString(assetdeliverydate),
          assetorderdate: dateToString(assetorderdate),
          networkcode: values.networkcode,
          tpidbroker: values.tpidbroker?.tpid,
          brokername: values.tpidbroker?.tpname,
          brokerreference: values.tpidbroker?.tpreference,
          assetstatus: form.getFieldValue('assetstatus'),
          assetnetamount: form.getFieldValue('assetnetamount'),
          assetfinamount:
            form.getFieldValue('assetfinamount') === 0 ||
            isNil(form.getFieldValue('assetfinamount')) ||
            form.getFieldValue('assetnetamount') !==
              form.getFieldValue('assetfinamount')
              ? form.getFieldValue('assetnetamount')
              : form.getFieldValue('assetfinamount'),
          degfeesformula:
            typeof values.degfeesformula === 'object'
              ? values.degfeesformula?.priid
              : values.degfeesformula,
          spfeesformula:
            typeof values.spfeesformula === 'object'
              ? values.spfeesformula?.priid
              : values.spfeesformula,
          tpofformula:
            typeof values.tpofformula === 'object'
              ? values.tpofformula?.priid
              : values.tpofformula,
          last_action: assetId
            ? wizData?.taskidUpdate ?? 0
            : wizData?.taskidCreate ?? 0,
          catalogid:
            state.unlockAssetModel === true
              ? null
              : form.getFieldValue('catalogid'),
          assetpictureurl: form.getFieldValue('assetpictureurl'),
          entityAddAttributList: entityAddAttributList ?? [],

          assetServiceList: asset?.assetServiceList ?? values.assetServiceList,
        };

        if (onSave) {
          form.resetFields();
          onSave(data);
          return;
        }
        if (assetId) {
          setLoadingBtn(true);

          updateAsset({
            assetRequest: data,
            assetid: assetId,
            phase: phaseprop,
            cteid: cteid,
          })
            .then((res) => {
              setLoadingBtn(false);

              if (res.code === '200') {
                notification.success({ message: res.message });
                history.push(`/asset/${res.data.assetid}/${phaseprop}`);
                refetch();
              } else {
                setLoadingBtn(false);

                notification.error({ message: res.message });
              }
            })
            .catch(() => {
              setLoadingBtn(false);
            });
        } else {
          createAsset({ assetRequest: data })
            .then((res) => {
              if (res.code === '200') {
                notification.success({ message: res.message });
                if (rederect) {
                  setisvisible();
                  history.push(`/asset/${res.data.assetid}/PROPOSAL`);
                } else {
                  form.resetFields();
                  history.push(`/asset/${res.data.assetid}/${phaseprop}`);
                  setLoadingBtn(false);
                }
              } else {
                notification.error({ message: res.message });
              }
              setLoadingBtn(false);
            })
            .catch(() => {
              setLoadingBtn(false);
            });
        }
      })
      .catch((errorInfo) => {
        console.log('catch error::', errorInfo);
        onFinishFailed(errorInfo);
        setLoadingBtn(false);
      });
  };
  const linkedCon = phaseprop === 'PROD' ? finComElements : comElements;

  // eslint-disable-next-line no-unused-vars
  const getName = (param: string, assetid: any) => {
    if (assetid === 0) {
      return ['elements', 'FIN', 0, param];
    } else {
      const index = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.assetid === assetid);
      return ['elements', 'FIN', index, param];
    }
  };

  const handelSelectOptions = (listOptions: any) => {
    if (listOptions?.length! > 0) {
      let lassetComponents: any[] = asset.assetComponents ?? [];
      if (!asset.assetmulticomponents) {
        lassetComponents.push({
          assetid: 0,
          compcategory: 'ASSET',
          compcategorylabel: asset.assetlabel,
          compdescription: asset.assetlabel,
          compdiscountamount: 0,
          compdiscountrate: 0,
          compfree1: '',
          compgrossamount: asset.assetgrossamount,
          compid: asset.catalogid,
          compnetamount: asset.assetnetamount,
          comporiginalnetamount: asset.assetunitnetamount,
          comptaxamount: asset.assetgrossamount - asset.assetnetamount,
          comptype: 'ASSET',
          comptypelabel: 'Asset',
          flagholdback: false,
          holdbackamount: 0,
          holdbackbeleasedate: '',
          holdbackbeleasenbdays: 0,
          holdbackpercentage: 0,
          suppliername: asset.suppliername,
          supplierreference: asset.supplierreference,
          taxcode: asset.taxcode,
          taxrate: asset.taxrate,
          tpidsupplier: asset.tpidsupplier,
        });
      }

      listOptions?.forEach((opt: any) => {
        if (
          asset?.assetComponents?.find(
            (assetComp: any) => assetComp?.compid !== opt?.optid
          )
        ) {
          lassetComponents.push({
            assetid: 0,
            compcategory: opt.optcode,
            compcategorylabel: opt.optcodelabel,
            compdescription: opt.optcodelabel + ' : ' + opt.optvaluelabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: opt.optgrossamount,
            compid: opt.optid,
            compnetamount: opt.optnetamount,
            comporiginalnetamount: opt.optnetamount,
            comptaxamount: opt.opttaxamount,
            comptype: 'OPT',
            comptypelabel: 'Option',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: asset.suppliername,
            supplierreference: asset.supplierreference,
            taxcode: opt.opttaxcode,
            taxrate: 0,
            tpidsupplier: asset.tpidsupplier,
          });
        }
      });

      form.setFieldsValue({
        assetmulticomponents: true,
        assetComponents: lassetComponents,
      });

      let assetunitnetamount = sumBy(lassetComponents, 'compnetamount');

      let assetqty = !isNil(form.getFieldValue('assetqty'))
        ? form.getFieldValue('assetqty')
        : 1;
      let assetnetamount = assetunitnetamount * assetqty;
      let assetfinamount = assetunitnetamount * assetqty;

      let assetunittaxamount = sumBy(lassetComponents, 'comptaxamount');
      let assettaxamount = sumBy(lassetComponents, 'comptaxamount') * assetqty;
      let assetunitgrossamount = sumBy(lassetComponents, 'compgrossamount');
      let assetgrossamount =
        sumBy(lassetComponents, 'compgrossamount') * assetqty;

      form.setFieldsValue({
        assetqty,
        assetfinamount,
        assetunitnetamount,
        assetnetamount,
        assetunittaxamount,
        assettaxamount,
        assetunitgrossamount,
        assetgrossamount,
      });
    }
  };

  return (
    <DF.Provider
      pagcode="assetdetail"
      entity="ASSET"
      entityid={(assetId ?? asset?.assetid) || 1}
      additionalAttribute={{
        entity: 'ASSET',
        object: phaseprop === 'PROPOSAL' ? 'ASSET' : 'FINASSET',
        assetfamily: objectParValueToString(state.assetfamily) ?? '',
        assettype: objectParValueToString(state.assettype) ?? '',
        assetcategory: objectParValueToString(state.assetcategory) ?? '',
        assetsegment: objectParValueToString(state.assetsegment) ?? '',
        assetmodel: objectParValueToString(state.assetmodel) ?? '',
      }}
    >
      <Page
        modalTitle={<GetLabel label="Asset details" />}
        showAsModal={showAsModal}
        visible={visible}
        onCancel={() => {
          onCancel!();
          form.resetFields();
        }}
        width="95%"
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={INITIAL_VALUES}
          onSubmitCapture={(e) => {
            onFinish();
          }}
        >
          <Row
            justify="space-between"
            gutter={2}
            style={{ fontSize: '14px', fontWeight: 'bold' }}
          >
            <Col span={8}>
              {!showAsModal ||
                (!rederect && (
                  <ArrowLeftOutlined
                    onClick={() => {
                      history.push(`/asset?phase=${phaseprop}`);
                    }}
                    style={{
                      float: 'left',
                      margin: '0px 5px',
                      fontSize: 'larger',
                    }}
                  />
                ))}
              {!showAsModal ? (
                assetId ? (
                  <>
                    <GetLabel label="Asset" />
                    {'  ' + asset?.assetreference + ' - ' + asset?.assetlabel}
                  </>
                ) : (
                  <Title level={4} comcode="NewAsset"></Title>
                )
              ) : asset ? (
                <>
                  <GetLabel label="Asset" />

                  {'  ' + asset?.assetreference + ' - ' + asset?.assetlabel}
                </>
              ) : (
                'New Asset'
              )}
            </Col>

            <Col>
              {tabPosition === 'left' && (
                <Row gutter={4} justify="end">
                  {!showAsModal && !assetId && (
                    <Col span={9}>
                      <FormItem shouldUpdate>
                        {({ getFieldValue }) => (
                          <AssetCatalogButton
                            onSelect={onAssetSelect}
                            fromextra
                            currcode={getFieldValue('currcode')}
                            styleModifiy
                          />
                        )}
                      </FormItem>
                    </Col>
                  )}
                  {!isNaN(Number(assetId)) && (
                    <>
                      <Col>
                        <IrvScheduleModal
                          irvSchedule={asset?.irvSchedule}
                          listContextFV={assetFV}
                          currcode={asset?.currcode}
                          controller={
                            <IrvScheduleButton
                              comcode="irvScheduleButton"
                              twoToneColor="red"
                              style={{
                                width: '100%',
                                height: 52,
                              }}
                            />
                          }
                        />
                      </Col>
                      {!hideActionBtn && (
                        <Col>
                          <TasksListPopover
                            status={
                              asset?.assetstatus ?? data?.assetstatus ?? ''
                            }
                            statusdate={data?.assetstatusdate ?? ''}
                            entityId={Number(assetId)}
                            entityReference={data?.assetreference}
                            entityName={
                              phaseprop === 'PROPOSAL' ? 'ASSET' : 'FINASSET'
                            }
                            title={
                              data?.assetreference + ' - ' + data?.assetlabel
                            }
                            onClose={() => {
                              refetch();
                              setrefetchMarketValues(!refetchMarketValues);
                              refetchassetuse();
                            }}
                          >
                            <Button
                              comcode="actions"
                              style={{ height: 52, width: '100%' }}
                              icon={<IActions />}
                            />
                          </TasksListPopover>
                        </Col>
                      )}
                    </>
                  )}
                  {fromproposal && asset?.assetCatalogAvailableOptions?.length && (
                    <Col>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('assetComponents')}
                      >
                        {({ getFieldValue }) => {
                          return (
                            <ModalControllerNV
                              modal={({ setVisible, visible }) => (
                                <AssetListOptionsModal
                                  onCancel={() => setVisible(false)}
                                  visible={visible}
                                  listOptions={
                                    asset.assetCatalogAvailableOptions ?? []
                                  }
                                  assetComponents={
                                    getFieldValue('assetComponents') ?? []
                                  }
                                  onSave={handelSelectOptions}
                                />
                              )}
                              content={({ setVisible, visible }) => (
                                <ButtonOperation
                                  comcode="addOptions"
                                  onClick={() => setVisible(true)}
                                  custom={{
                                    height: 52,
                                  }}
                                />
                              )}
                            />
                          );
                        }}
                      </Form.Item>
                    </Col>
                  )}

                  {!hideSaveBtn && (
                    <Col>
                      <SaveButton
                        loading={loadingBtn}
                        comcode="save"
                        custom={{ height: 52 }}
                      />
                    </Col>
                  )}
                </Row>
              )}
            </Col>
          </Row>

          <Form.Item
            noStyle
            shouldUpdate={shouldUpdateCompare([
              'assetmulticomponents',
              'currcode',
            ])}
          >
            {({ getFieldValue }) => {
              return (
                <WizardTabs
                  entity="ASSET"
                  entityid={assetId ?? asset?.assetid}
                  taskid={
                    assetId
                      ? wizData?.taskidDisplay ?? 0
                      : wizData?.taskidCreate ?? 0
                  }
                  defaultTabs={[
                    'tabAsset',
                    'tabAssetComponent',
                    'tabAssetService',
                  ]}
                  hiddenTabs={
                    phaseprop === 'PROPOSAL' &&
                    form.getFieldValue('assetmulticomponents')
                      ? [
                          'tabAssetDepreciation',
                          'tabAssetMarketValue',
                          'tabAccounting',
                          'tabAssetMarketValue',
                          'tabAccounting',
                          'tabAssetRepossession',
                        ]
                      : phaseprop === 'PROPOSAL' &&
                        !form.getFieldValue('assetmulticomponents')
                      ? [
                          'tabAssetComponent',
                          'tabAssetDepreciation',
                          'tabAssetMarketValue',
                          'tabAccounting',
                          'tabAssetMarketValue',
                          'tabAccounting',
                          'tabAssetRepossession',
                        ]
                      : phaseprop === 'PROD' &&
                        !form.getFieldValue('assetmulticomponents')
                      ? ['tabAssetComponent']
                      : !form.getFieldValue('assetmulticomponents')
                      ? ['tabAssetComponent']
                      : []
                  }
                  tabs={{
                    tabAsset: (
                      <AssetGeneralData
                        assettaxamount={assettaxamount}
                        form={form}
                        isCreate={isCreate}
                        flagreal={flagreal ?? false}
                        linkedCon={
                          linkedCon !== undefined && linkedCon?.length !== 0
                            ? true
                            : false
                        }
                        showAsModal={display}
                        status={form.getFieldValue('assetstatus')}
                        fromproposal={fromproposal}
                        assetId={assetId}
                        phase={phaseprop}
                        setState={setState}
                        state={state}
                      />
                    ),
                    tabAssetComponent: (
                      <AssetComponents
                        phase={phaseprop ?? 'PROPOSAL'}
                        form={form}
                        linkedCon={
                          linkedCon !== undefined && linkedCon?.length !== 0
                            ? true
                            : false
                        }
                        iscreate={isCreate}
                        showAsModal={display}
                        status={asset?.assetstatus ?? data?.assetstatus}
                        fromproposal={fromproposal}
                      />
                    ),
                    tabAssetUse: (
                      <TabAssetUse
                        fromproposal={fromproposal}
                        form={form}
                        assetPhase={phaseprop}
                        irvSchedule={asset?.irvSchedule}
                        assetDetail={
                          !isNil(asset)
                            ? {
                                assetid: asset.assetid,
                                catalogid: asset.catalogid,
                                assetfamily: asset.assetfamily,
                                assettype: asset.assettype,
                                assetsegment: asset.assetsegment,
                                assetmodel: asset.assetmodel,
                                assetcategory: asset.assetcategory,
                                currcode: asset.currcode,
                                assetnetamount: asset.assetnetamount,
                                assetstatus: asset.assetstatus,
                              }
                            : null
                        }
                        proposalData={proposalData}
                        assetFV={assetFV}
                        refetchassetFV={refetchassetFV}
                        refetchassetUse={refetchassetuse}
                        isAssetCreate={isCreate}
                        isproposalcreate={isproposalcreate}
                      />
                    ),
                    tabAssetSchedule: (
                      <Card
                        title={
                          <GetLabel
                            label="assetPaymentSchedule"
                            style={{ fontWeight: 'bold', paddingLeft: 15 }}
                          />
                        }
                      >
                        <TabAssetSchedule
                          form={form}
                          assetId={assetId}
                          isCreate={isCreate}
                          showAsModal={display}
                          title
                        />
                      </Card>
                    ),

                    tabAssetExtraInfo: (
                      <AssetExtraInfo form={form} state={state} />
                    ),

                    tabAssetDepreciation: (
                      <AssetDeprecation
                        assetid={assetId}
                        currcode={form.getFieldValue('currcode')}
                      />
                    ),

                    tabAssetConelement: (
                      <AssetConElement
                        data={linkedCon}
                        currcode={form.getFieldValue('currcode')}
                        ctstatus={ctstatus}
                        phase={phaseprop}
                      />
                    ),
                    tabSupplierInvoiceasset: (
                      <SIList
                        assetProd
                        ctref={linkedCon && linkedCon[0]?.ctreference}
                      />
                    ),
                    tabAssetMarketValue: (
                      <AssetMarketValue
                        assetId={assetId}
                        showAsModal={display}
                        currcode={getFieldValue('currcode')}
                        status={asset?.assetstatus ?? data?.assetstatus}
                        fromproposal={fromproposal}
                        refetchMarketValues={refetchMarketValues}
                      />
                    ),
                    tabUpload: (
                      // <Card title={<GetLabel label="assetDocuments" style={{fontWeight:'bold',paddingLeft:15}}/>}>
                      <DocList
                        objectid={assetId}
                        objecttype="ASSET"
                        categorie="DOC"
                        title
                        showAsModal={display}
                        status={asset?.assetstatus ?? data?.assetstatus}
                        fromproposal={fromproposal}
                        objectreference={data?.assetreference}
                      />
                      // </Card>
                    ),
                    tabAccounting: (
                      <Card
                        title={
                          <GetLabel
                            label="assetAccounting"
                            style={{ fontWeight: 'bold', paddingLeft: 15 }}
                          />
                        }
                      >
                        <Accounting
                          objectid={assetId!}
                          objecttype="ASSET"
                          title
                        />
                      </Card>
                    ),
                    assetAdress: (
                      <AssetAdress
                        assetid={assetId!}
                        showAsModal={showAsModal}
                        form={form}
                      />
                    ),
                    assetUsers: (
                      <AssetUsers id={assetId!} showAsModal={showAsModal} />
                    ),
                    tabProcessFollowup: (
                      <Card>
                        <ProcessFollowUp
                          entity={
                            phaseprop === 'PROPOSAL' ? 'ASSET' : 'FINASSET'
                          }
                          entityid={assetId!}
                          entityReference={asset?.assetreference}
                        />
                      </Card>
                    ),
                    tabAssetRepossession: (
                      <AssetRepossession assetid={assetId!} />
                    ),
                    tabAssetService: (
                      <AssetServices
                        asset={data}
                        form={form}
                        assetid={assetId!}
                        refetchassetServices={refetchassetServices}
                        isFetching={isFetching}
                      />
                    ),
                    tabFees: (
                      <AssetFees
                        assetId={Number(assetId)}
                        currcode={form.getFieldValue('currcode')}
                        phase="PROD"
                      />
                    ),
                    tabAssetLinks: (
                      <AssetLinksListCard
                        assetId={Number(assetId)}
                        showAsModal={showAsModal}
                      />
                    ),
                  }}
                  tabBarExtraContent={
                    tabPosition === 'top'
                      ? (Number(assetId) ? (
                          <TasksListPopover
                            status={
                              asset?.assetstatus ?? data?.assetstatus ?? ''
                            }
                            statusdate={data?.assetstatusdate ?? ''}
                            entityReference={data?.assetreference}
                            entityId={Number(assetId)}
                            entityName={
                              phaseprop === 'PROPOSAL' ? 'ASSET' : 'FINASSET'
                            }
                            title={
                              data?.assetreference + ' - ' + data?.assetlabel
                            }
                            onClose={refetch}
                          >
                            <Button comcode="actions" />
                          </TasksListPopover>
                        ) : null) && (
                          <SaveButton loading={loadingBtn} comcode="save" />
                        )
                      : null
                  }
                />
              );
            }}
          </Form.Item>
        </Form>
      </Page>
    </DF.Provider>
  );
};

const INITIAL_VALUES: any = {
  assetphase: '',
  assetcategory: null as any,
  assetComponents: [],
  assetconstructor: '',
  assetdeliverydate: '', // ($date)
  assetdeliveryreference: '',
  assetdescription: '',
  assetgrossamount: 0,
  assetid: 0,
  assetlabel: '',
  assetmodel: '',
  assettaggrouping: '',
  assetmulticomponents: false,
  assetnetamount: 0,
  assetorderdate: '', // ($date)
  assetorderreference: '',
  assetreference: '',
  assetrisklevel: null as any,
  assetstatus: 'INIT',
  assettaxamount: 0,
  assettype: null as any,
  deliveryadrcountry: '',
  finAssetComponents: [],
  fiscaldepreciationmethod: '',
  flagused: false,
  serialno: '',
  taxcode: '',
  taxrate: 0,
  tpidsupplier: null as any,
  plateno: '',
  power: '',
  weight: '',
  chassisno: '',
  engineno: '',
  registrationno: '',
  kwhpower: '',
  kwhproduction: '',
  kwhdegradation: '',
  deliveryadrregion: '',
  deliveryadrstreet1: '',
  deliveryadrstreet2: '',
  deliveryadrzipcode: '',
  deliveryadrcity: '',
  suppliername: '',
  supplierreference: '',
};

export default AssetDetails;
